module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-verde_old.2d2c55fc.svg";